import { Injectable } from "@angular/core";

/*
  Generated class for the LocalStorage provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/

@Injectable()
export class LocalStorage {
  // constructor(){}
  static _() {
    return new LocalStorage();
  }
  get(key: string) {
    return window.localStorage.getItem(key);
  }

  set(key: string, value: any) {
    return window.localStorage.setItem(key, value);
  }

  destroy(key: string) {
    return window.localStorage.removeItem(key);
  }
}
